/*
 * Modal ingredients table
 */

var modal = document.getElementById('PDPAlternate-modalID')
var btn = document.getElementById('PDPAlternate-modal-btn')
var span = document.getElementsByClassName('js-PDPAlternate-modal-close-1')[0]
var modal2 = document.getElementById('PDPAlternate-modalID2')
var btn2 = document.getElementById('PDPAlternate-modal-btn2')
var btn3 = document.getElementById('PDPAlternate-modal-btn3')
var btn4 = document.getElementById('PDPAlternate-modal-btn4')
var span2 = document.getElementsByClassName('js-PDPAlternate-modal-close-2')[0]

const subscribePrice = document.querySelector('.rc_widget__price--subsave')

const oneTimePrice = document.querySelector('.rc_widget__price--onetime')

document.querySelector('body').addEventListener('click', function (e) {
  if (
    !e.target == document.querySelector('.rc_popup__block') ||
    !e.target.closest('.rc_popup__block')
  ) {
    const popupElement = document.querySelector('.rc_popup');
    if (popupElement) {
      popupElement.classList.remove('is-open');
    }
  }

  if (
    e.target == document.querySelector('.rc_popup_label_wrapper') ||
    e.target.closest('.rc_popup_label_wrapper')
  ) {
    document.querySelector('.rc_popup').classList.add('is-open')
  }

  if (e.target.classList.contains('rc_widget__option__input--subsave')) {
    subscribePrice.classList.remove('hidden')
    oneTimePrice.classList.add('hidden')
  }

  if (e.target.classList.contains('rc_widget__option__input--onetime')) {
    subscribePrice.classList.add('hidden')
    oneTimePrice.classList.remove('hidden')
  }
})

if (btn != null) {
  btn.onclick = function () {
    modal.style.display = 'block'
    modal.style.opacity = 1
  }
}
if (btn2 != null) {
  btn2.onclick = function () {
    modal.classList.add('is-open')
    document.body.style.overflow = 'hidden'
    modal.style.opacity = 1
  }
}
if (btn3 != null) {
  btn3.onclick = function () {
    modal2.classList.add('is-open')
    document.body.style.overflow = 'hidden'
  }
}
if (btn4 != null) {
  btn4.onclick = function () {
    modal2.classList.add('is-open')
    document.body.style.overflow = 'hidden'
  }
}
if (span != null) {
  span.onclick = function () {
    modal.classList.remove('is-open')
    document.body.style.overflow = 'unset'
    modal.style.opacity = 0
  }
}
if (span2 != null) {
  span2.onclick = function () {
    modal2.classList.remove('is-open')
    document.body.style.overflow = 'unset'
  }
}

window.onclick = function (event) {
  if (event.target == modal2) {
    modal2.classList.remove('is-open')
    document.body.style.overflow = 'unset'
  }

  if (event.target == modal) {
    document.body.style.overflow = 'unset'
    modal.classList.remove('is-open')
  }
}
